import { immerable } from "immer";
import { filtersTypeEnum } from "@sttedra_ui/framework";

import { tableViews, useSmallAddLabel } from "@/composables/_commons/helper.js";
import { dataSourcesList } from "@/api/data-sources/data-sources.api.js";

export default class DataSourcesTableConfig {
  [immerable] = true;

  constructor(buildModal, deleteRegister) {
    const fields = [
      {
        field: "titulo",
        label: "Título",
      },
      {
        field: "host",
        label: "Host",
      },
      {
        field: "nombreBbdd",
        label: "Base de datos",
      },
      {
        field: "usuario",
        label: "Usuario",
      },
      {
        field: "queriesAsignadas",
        label: "Informes",
        sortable: false,
      },
    ];

    const advancedFilters = [
      {
        field: "titulo",
        label: "Título",
      },
      {
        field: "host",
        label: "Host",
      },
      {
        field: "nombreBbdd",
        label: "Base de datos",
      },
      {
        field: "usuario",
        label: "Usuario",
      },
    ];

    return {
      title: "Fuentes de datos",
      api: dataSourcesList,
      schema: fields,
      actions: {
        header: [
          {
            label: useSmallAddLabel() ? "Añadir" : "Añadir fuente de datos",
            icon: "add",
            command: () => buildModal(),
            extended: true,
          },
        ],
        item: [
          {
            label: "Clonar",
            icon: "content_copy",
            command: (event) => buildModal(event, "copy"),
            extended: false,
          },
          {
            label: "Editar",
            icon: "edit",
            command: (event) => buildModal(event),
            extended: false,
          },
          {
            label: "Borrar",
            icon: "delete",
            command: (event) => deleteRegister(event),
            extended: false,
            classObj: ["delete-action"],
            disabled: (data) => data.queriesAsignadas > 0,
          },
        ],
      },
      filters: [
        {
          type: filtersTypeEnum.GLOBAL,
          fields: advancedFilters,
        },
        {
          type: filtersTypeEnum.ADVANCED,
          fields: advancedFilters,
        },
      ],
      views: tableViews(),
    };
  }
}
